"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForgotPasswordComponent = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
const router_1 = require("@angular/router");
//INTERNAL LIBRARY BITS
const notification_service_1 = require("./notification.service");
const users_service_1 = require("./users.service");
let ForgotPasswordComponent = class ForgotPasswordComponent {
    constructor(_talk, _users, _router) {
        this._talk = _talk;
        this._users = _users;
        this._router = _router;
    }
    ngOnInit() {
        document.getElementById("user-forgot-password")
            .addEventListener("keyup", function (event) {
            event.preventDefault();
            if (event.keyCode == 13) {
                document.getElementById("submit").click();
            }
        });
    }
    forgotPassword(email, confirmEmail) {
        if (email !== confirmEmail) {
            return this._talk.broadcast("The emails submitted do not match.");
        }
        if (!/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,8}$/i.test(email)) {
            this._talk.broadcast(`Oops! It looks like that email is invalid, please try again <i class="fa fa-smile-o" aria-hidden="true"></i>`);
            return;
        }
        return Promise.resolve(this._users.forgotPassword(email, true)).then(err => {
            return true;
        });
    }
};
exports.ForgotPasswordComponent = ForgotPasswordComponent;
exports.ForgotPasswordComponent = ForgotPasswordComponent = __decorate([
    (0, core_1.Component)({
        selector: 'my-forgot-password',
        templateUrl: 'app/forgot-password.component.html'
    }),
    __metadata("design:paramtypes", [notification_service_1.NotificationService,
        users_service_1.UsersService,
        router_1.Router])
], ForgotPasswordComponent);
//# sourceMappingURL=forgot-password.component.js.map